<template>
  <v-tabs v-model="tabActive">
    <v-tab
      v-for="tab in tabs"
      :key="tab"
      @click="updateTab(tab)"
    >
      {{ tab }}
    </v-tab>

    <v-tabs-items v-model="tabActive">
      <v-tab-item :transition="false">
        <SectionFanbase
          v-if="tabName === tabs[0]"
          :key-followers-by-channel="keyFollowersByChannel"
        />
      </v-tab-item>

      <v-tab-item :transition="false">
        <SectionPublications v-if="tabName === tabs[1]" />
      </v-tab-item>

      <v-tab-item :transition="false">
        <SectionInteractions v-if="tabName === tabs[2]" />
      </v-tab-item>

      <v-tab-item :transition="false">
        <SectionSentiments v-if="tabName === tabs[3]" />
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>

<script>
import SectionFanbase from './SectionFanbase.vue';
import SectionPublications from './SectionPublications.vue';
import SectionInteractions from './SectionInteractions.vue';
import SectionSentiments from './SectionSentiments.vue';

import { dispatchMixpanelTrack } from '@/utils';

export default {
  name: 'BenchmarksTabs',
  components: {
    SectionFanbase,
    SectionPublications,
    SectionInteractions,
    SectionSentiments,
  },
  props: {
    keyFollowersByChannel: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      tabActive: 0,
      tabs: ['Base de fãs', 'Publicações', 'Interações', 'Sentimentos'],
    };
  },
  computed: {
    tabName() {
      return this.tabs.find((_, index) => index === this.tabActive);
    },
  },
  mounted() {
    this.$store.dispatch('ui/addTabName', this.tabName);
  },
  methods: {
    updateTab(tab) {
      this.$store.dispatch('ui/addTabName', tab);

      dispatchMixpanelTrack('BM Tab Page Click', ['network', 'tab']);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-tab {
    color: var(--ds-color-text-2);
    caret-color: var(--ds-color-text-2);
    text-transform: initial;
    font-size: var(--ds-font-size-sm);
    font-weight: var(--ds-font-weight-semibold);
    letter-spacing: normal;
    padding: 0;

    .v-ripple {
      &__container {
        display: none;
      }
    }

    &::before {
      opacity: 0 !important;
    }

    &--active {
      color: var(--ds-color-text-1);
      caret-color: var(--ds-color-text-1);
    }
  }

  .v-tabs-bar,
  .v-window-item {
    margin-bottom: var(--ds-spacing-stack-md);
  }

  .v-tabs-slider {
    width: 90%;
    margin: 0 auto;

    &-wrapper {
      color: var(--ds-color-text-1);
    }
  }
}
</style>
